"use client"

import { CakeSlice } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CakeSliceIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CakeSliceIcon = component(Icon)({ as: CakeSlice })
